import { isBulkBatchTargetId } from '@/lib/bulkProcessQueueState';
import { isBulkEnqueueListLagState } from '@/lib/bulkProcessQueueSync';
import type { Application, ApplicationState } from '@/types';

type PipelineRunLike = {
  state?: string;
  decidedBy?: string;
};

/** System-triggered screening run exists and the application has not started executing yet. */
export function hasActiveSystemScreeningRun(
  pipelineRuns: readonly PipelineRunLike[] | undefined,
): boolean {
  return (pipelineRuns ?? []).some(
    (run) => run.state === 'RUNNING' && run.decidedBy === 'system',
  );
}

export function deriveScreeningQueued(
  state: ApplicationState,
  pipelineRuns: readonly PipelineRunLike[] | undefined,
): boolean {
  if (!isBulkEnqueueListLagState(state)) return false;
  return hasActiveSystemScreeningRun(pipelineRuns);
}

export function isApplicationAwaitingScreeningSlot(
  app: Pick<Application, 'state' | 'screeningQueued'>,
): boolean {
  return !!app.screeningQueued && isBulkEnqueueListLagState(app.state);
}

/** Posting/auto-apply rows in screening — excluded from the active bulk batch counter. */
export function countInboundScreeningApplications(
  apps: readonly Application[],
  companyId: string | undefined,
): number {
  if (!companyId) return 0;
  return apps.filter((app) => {
    if (isBulkBatchTargetId(companyId, app.id)) return false;
    if (app.state === 'PIPELINE_RUNNING') return true;
    return isApplicationAwaitingScreeningSlot(app);
  }).length;
}
